(function () {
  var gallery = document.querySelector('[data-story-detail]');
  if (!gallery) return;

  var image = gallery.querySelector('.story-overlay__image');
  var video = gallery.querySelector('.story-overlay__video');
  var caption = gallery.querySelector('[data-story-detail-caption]');
  var counter = gallery.querySelector('[data-story-detail-counter]');
  var footer = gallery.querySelector('[data-story-detail-footer]');
  var previous = gallery.querySelector('[data-story-detail-prev]');
  var next = gallery.querySelector('[data-story-detail-next]');
  if (!image || !video || !caption || !counter || !footer) return;

  var media;
  try { media = JSON.parse(gallery.dataset.storyMedia || '[]'); } catch (error) { media = []; }
  if (!media.length) {
    var images;
    var captions;
    try { images = JSON.parse(gallery.dataset.storyImages || '[]'); } catch (error) { images = []; }
    try { captions = JSON.parse(gallery.dataset.storyCaptions || '[]'); } catch (error) { captions = []; }
    media = images.map(function (src, mediaIndex) {
      return { type: 'image', src: src, caption: captions[mediaIndex] || '' };
    });
  }
  if (!media.length) return;

  var index = 0;
  var alignmentFrame = null;
  var preloadFrame = null;
  var preloadedImages = {};

  function preferredImageWidth() {
    var availableWidth = window.innerWidth <= 599 ? window.innerWidth - 30 : 760;
    var pixelWidth = Math.max(1, availableWidth) * Math.min(window.devicePixelRatio || 1, 2);
    var widths = [480, 760, 1200, 1600, 2400];

    for (var widthIndex = 0; widthIndex < widths.length; widthIndex += 1) {
      if (pixelWidth <= widths[widthIndex]) return widths[widthIndex];
    }
    return widths[widths.length - 1];
  }

  function sizedImageUrl(path) {
    if (!path || path.indexOf('/cdn/shop/') === -1) return path || '';

    var width = preferredImageWidth();
    if (/([?&])width=\d+/.test(path)) {
      return path.replace(/([?&])width=\d+/, '$1width=' + width);
    }
    return path + (path.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function preloadItem(item) {
    if (!item) return;
    var source = item.type === 'video' ? item.poster : item.src;
    var url = sizedImageUrl(source);
    if (!url || preloadedImages[url]) return;

    var preload = new Image();
    preload.decoding = 'async';
    preload.fetchPriority = 'low';
    preload.src = url;
    preloadedImages[url] = preload;
  }

  function preloadNearby() {
    if (media.length < 2) return;
    [1, 2, -1].forEach(function (offset) {
      var nearbyIndex = (index + offset + media.length) % media.length;
      if (nearbyIndex !== index) preloadItem(media[nearbyIndex]);
    });
  }

  function schedulePreload() {
    window.cancelAnimationFrame(preloadFrame);
    preloadFrame = window.requestAnimationFrame(preloadNearby);
  }

  function clearVideo() {
    video.pause();
    video.removeAttribute('poster');
    while (video.firstChild) video.removeChild(video.firstChild);
    video.load();
  }

  function activeElement() {
    return video.hidden ? image : video;
  }

  function intrinsicSize(element) {
    if (element === video) return { width: video.videoWidth, height: video.videoHeight };
    return { width: image.naturalWidth, height: image.naturalHeight };
  }

  function updateFooterAlignment() {
    window.cancelAnimationFrame(alignmentFrame);
    alignmentFrame = window.requestAnimationFrame(function () {
      var element = activeElement();
      var size = intrinsicSize(element);
      if (!size.width || !size.height) return;

      var mediaBox = element.getBoundingClientRect();
      if (!mediaBox.width || !mediaBox.height) return;

      var mediaRatio = size.width / size.height;
      var boxRatio = mediaBox.width / mediaBox.height;
      var renderedWidth = mediaRatio > boxRatio ? mediaBox.width : mediaBox.height * mediaRatio;
      var renderedHeight = mediaRatio > boxRatio ? mediaBox.width / mediaRatio : mediaBox.height;
      var bottomInset = Math.max(0, (mediaBox.height - renderedHeight) / 2);

      footer.style.width = renderedWidth + 'px';
      footer.style.transform = 'translateY(-' + bottomInset + 'px)';
      footer.style.visibility = '';
    });
  }

  function render() {
    var item = media[index];
    footer.style.visibility = 'hidden';
    clearVideo();

    if (item.type === 'video') {
      image.hidden = true;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      video.hidden = false;
      video.setAttribute('aria-label', (gallery.dataset.storyTitle || '') + ' — Video ' + (index + 1));
      if (item.poster) video.poster = item.poster;
      (item.sources || []).forEach(function (sourceData) {
        if (!sourceData.src) return;
        var source = document.createElement('source');
        source.src = sourceData.src;
        if (sourceData.type) source.type = sourceData.type;
        video.appendChild(source);
      });
      video.load();
    } else {
      video.hidden = true;
      image.hidden = false;
      image.classList.remove('is-image-loaded');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = sizedImageUrl(item.src);
      image.alt = (gallery.dataset.storyTitle || '') + ' — Image ' + (index + 1);
      if (image.complete) updateFooterAlignment();
    }

    caption.textContent = item.caption || gallery.dataset.storyCaption || '';
    counter.textContent = (index + 1) + ' / ' + media.length;
    schedulePreload();
  }

  function step(delta) {
    if (media.length < 2) return;
    index = (index + delta + media.length) % media.length;
    render();
  }

  if (previous) previous.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });
  image.addEventListener('load', updateFooterAlignment);
  video.addEventListener('loadedmetadata', updateFooterAlignment);
  window.addEventListener('resize', updateFooterAlignment);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });

  render();
})();
